export default __webpack_public_path__ + "static/media/main-token-2.3ec8aa93.webp";